export interface ActorJson {
  id?: string;
  type?: string;
  email?: string;
  last_name?: string;
  first_name?: string;
  name?: string;
}

export class Actor {
  constructor(
    public id?: string,
    public type?: string,
    public email?: string,
    public lastName?: string,
    public firstName?: string,
    public name?: string
  ) {}

  static fromJson(actorJson: ActorJson): Actor {
    return new Actor(
      actorJson.id,
      actorJson.type,
      actorJson.email,
      actorJson.last_name,
      actorJson.first_name,
      actorJson.name
    );
  }
}
